// Simple network checker that tests actual connectivity
export const checkNetworkConnection = async (): Promise<boolean> => {
  try {
    // Try to fetch a tiny request from our own server
    // We use a timestamp to prevent caching
    const response = await fetch(`/api/health?timestamp=${Date.now()}`, {
      method: 'HEAD',  // We only need the headers, not the body
      cache: 'no-store',  // Never use cache
    });
    
    return response.ok;
  } catch (error) {
    console.log('Network check failed:', error);
    return false;
  }
}; 